module.exports = __webpack_public_path__ + "static/img/7.40bde66.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/eng/7.png
// module id = jSu6
// module chunks = 0